import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Cookies from "js-cookie";

import { shopActions } from "./redux/shop/shop.reducer";
import { cartActions } from "./redux/cart/cart.reducer";
import { userActions } from "./redux/user/user.reducer";

import { selectCurrentUser } from "./redux/user/user.selectors";
// import { addItem } from "./redux/cart/cart.utils";

import Header from "./components/header";
import NavBar from "./components/nav-bar";
import Routes from "./routes";
import Cart from "./components/cart";
import ScrollTopButton from "./components/scroll-top-button";

const fetchCollections = (dispatch: any) => {
  dispatch({
    type: shopActions.fetchAllCollectionsStart.type,
  });
};

const fetchAllBrands = (dispatch: any) => {
  dispatch({
    type: shopActions.fetchAllBrandsStart.type,
  });
};

const fetchCart = (dispatch: any, currentUser: any) => {
  dispatch({
    type: cartActions.fetchCartStart.type,
    payload: currentUser?.nickname,
  });
};

const signIn = (dispatch: any, username: string | undefined) => {
  dispatch({
    type: userActions.signInStart.type,
    payload: username,
  });
};

const signOut = (dispatch: any) => {
  dispatch({
    type: userActions.signOutStart.type,
  });
};

const addItems = (dispatch: any, currentUser: any, items: any) => {
  dispatch({
    type: cartActions.addItemStart.type,
    payload: {
      userId: currentUser.nickname,
      cartItemsToAdd: items,
    },
  });
};

const App = () => {
  const dispatch = useDispatch();

  const { pathname, search } = useLocation();

  const currentUser = useSelector(selectCurrentUser);

  useEffect(() => {
    window.scrollTo({
      top: 0,
    });
  }, [pathname, search]);

  useEffect(() => {
    fetchCollections(dispatch);
    fetchAllBrands(dispatch);
  }, []);

  useEffect(() => {
    if (Cookies.get("idToken")) {
      signIn(dispatch, Cookies.get("username"));
    } else {
      signOut(dispatch);
    }
  }, [Cookies]);

  const addAllItemsToCart = () => {
    const cartItemsLocalStorage = localStorage.getItem("cartItems");
    const cartInfoLocalStorage = localStorage.getItem("cartInfo");

    let cartInfo = {
      hasTriedToAdd: false,
      isAddedSuccessfully: false,
    };
    let cartItems = [];

    if (cartItemsLocalStorage) {
      cartItems = JSON.parse(cartItemsLocalStorage);
    }

    if (cartInfoLocalStorage) {
      cartInfo = { ...cartInfo, ...JSON.parse(cartInfoLocalStorage) };
    }

    if (
      cartItemsLocalStorage &&
      cartItems.length !== 0 &&
      !cartInfo.hasTriedToAdd &&
      !cartInfo.isAddedSuccessfully
    ) {
      addItems(dispatch, currentUser, cartItems);

      cartInfo.hasTriedToAdd = true;
      localStorage.setItem("cartInfo", JSON.stringify(cartInfo));
    }
  };

  useEffect(() => {
    if (currentUser) {
      addAllItemsToCart();
      fetchCart(dispatch, currentUser);
    }
  }, [currentUser]);

  return (
    <>
      {pathname.includes("checkout") && !pathname.includes("cart") ? null : (
        <Header />
      )}
      {pathname.includes("checkout") ? null : <NavBar />}
      <Routes />
      <Cart />
      <ScrollTopButton />
    </>
  );
};

export default App;
